import styled from "styled-components";

export const FooterModal = styled.div`
   display: flex;
   width: 100%;
   justify-content: space-between;
   align-items: center;
`;

export const ContainerModal = styled.div`
  font-size: 20px;
  color: #334155;
  line-height: 1.6;
  padding-top: 10px;

`;

export const Span = styled.span`
  font-size: 12px;
  color: #94a3b8;
  margin-top: 10px
`;
